<template>
  <Layout style="min-height: 80vh">


    <!-- MAIN HEADER -->
    <Header class="main-header" :class="{'main-header__home': current_view.name === 'home'}">

      <div class="d-flex align-center">
        <!--Бургер для главной страницы-->
        <div v-if="current_view.name === 'home' && isDesktop"
             class="menuBtn"
             style="opacity: 0.3;"
        >
          <img src="/static/svg/burger.svg" alt="">
        </div>

        <!--Бургер для остальных страниц-->
        <div @click="modal9 = true, closeBurger = true"
             style="cursor: pointer"
             class="menuBtn"
             v-if="current_view.name != 'home' || isLaptop || isMobile">
          <img src="/static/svg/burger.svg" alt="">
        </div>

        <div class="menuBtn closeBurger"
             @click="modal9 = false, closeBurger = false"
             v-if="closeBurger && modal9 === true"
             style="cursor: pointer">
          <img src="/static/svg/closeBurger.svg" alt="">
        </div>


        <router-link class="mainLogo" :to="{ name: 'home' }"
        >
          <img src="/static/img/logo.png" alt="">
        </router-link
        >

        <div class="layout-view-name" v-if="current_view.name != 'home'">
          <h3>{{ current_view.label }}</h3>
        </div>
      </div>


      <div class="d-flex align-center">
        <!--Касса-->
        <a :href="kassa_addr"

           class="cash-box">
          <h2>
            Касса
          </h2>
        </a>


        <div class="d-flex align-center">
          <div class="header-icons custom-dropdown">

            <Dropdown :visible="videoListModal" trigger="custom" class="header-icons videoList">
              <div class="header-icons__box cursor-pointer"
                   @click="showVideoList()"
                   :class="{active: videoListModal === true}">
                <img src="/static/svg/video.svg" alt="" v-if="!videoListModal">
                <img src="/static/svg/video_active.svg" alt="" v-if="videoListModal">
              </div>

              <DropdownMenu slot="list">

                <h3 class="mb-30">Видеоинструкции</h3>

                  <div class="card-container"
                       v-for="item in videoList"
                       @click="showVideo(item)"
                       :class="{active: activeVideo.name === item.name}"
                       >
                    <DropdownItem>
                      {{item.name}}
                    </DropdownItem>

                  </div>
              </DropdownMenu>
            </Dropdown>



<!--            <div class="header-icons__box">-->
<!--              <img src="/static/img/header_icons/icon_2.png" alt="">-->
<!--            </div>-->
<!--            -->
<!--            <div class="header-icons__box">-->
<!--              <img src="/static/img/header_icons/icon_3.png" alt="">-->
<!--              <span class="notification">23</span>-->
<!--            </div>-->
          </div>
        </div>


        <div class="card-container layout-profile__main"

             v-if="current_view.name === 'home' && isDesktop">

          <Avatar v-if='user_img'>
            <img :src="server_addr + user_img" alt="">
          </Avatar>

          <Avatar v-else>
            <img src="/static/img/user_avatar_60x60.png" alt="">
          </Avatar>

          <div class="layout-profile__body">
            <h2>{{ user_full_name }}</h2>

            <router-link :to="`/user/detail/${user_id}`" class="card-container">
              Профиль клиента
            </router-link>
            <Button type="primary" @click="modalPassword = true" class="card-container">
              Сменить пароль
            </Button>

            <Modal v-model="modalPassword" :footer-hide="footerHide" v-if="current_view.name === 'home'">
              <modalPass>
              </modalPass>
            </Modal>


            <MenuItem name="3-2" @click.native="logout" class="logout">
              <span>Выйти</span>
            </MenuItem>
          </div>


        </div>

        <div class="layout-profile card-container"
             v-if="current_view.name != 'home' || isLaptop || isMobile">
          <Menu
            mode="horizontal"
            active-name="1"
          >
            <Submenu name="3" class="ls-main-menu-item">
              <template slot="title">

                <Avatar v-if='user_img'>
                  <img :src="server_addr + user_img" alt="">
                </Avatar>

                <Avatar v-else>
                  <img src="/static/img/user_avatar_60x60.png" alt="">
                </Avatar>

                <span class="name">{{ user_full_name }}</span>

                <!--<br>-->
              </template>
              <MenuGroup :title="role_display" class="layout-profile__body">
                <router-link :to="`/user/detail/${user_id}`" class="card-container">
                  Профиль клиента
                </router-link>
                <Button type="primary" @click="modalPassword = true" class="card-container">
                  Сменить пароль
                </Button>

                <Modal v-model="modalPassword" :footer-hide="footerHide" v-if="current_view.name != 'home'">
                  <modalPass>
                  </modalPass>
                </Modal>

                <MenuItem name="3-2" @click.native="logout" class="logout">
                  <span>Выйти</span>
                </MenuItem>
              </MenuGroup>
            </Submenu>
          </Menu>


        </div>

      </div>

      <div class="custom-wrap" v-if="videoListModal" @click="videoListModal = false"></div>

    </Header>


    <!--Главное меню МОДАЛЬНОЕ ОКНО-->
    <Modal
      class="modalMenu"
      v-model="modal9"
      :styles="{top: '0', left: '0', height: '100vh', marginLeft: '0'}">

      <div class="mainMenu">
        <div @click="modal9 = false" style="grid-area: a">
          <MenuItem v-if="display_home" name="home" :to="{ name: 'home' }"
          >
            <div class="info-box">
              🏠 <br>
              <span>{{ getView("home").label }}</span>
            </div>
            <img src="/static/img/menu_background/main.png" alt="">
          </MenuItem>
        </div>

        <div @click="modal9 = false" style="grid-area: b">
          <MenuItem

            v-if="permissions.indexOf('catalog.product_app') !== -1"
            name="catalog"
            :to="getView('catalog').children[0]"
          >
            <div class="info-box">
              🎁<br/>
              <span>{{ getView("catalog").label }}</span>
            </div>
            <img src="/static/img/menu_background/products.png" alt="">
          </MenuItem>
        </div>

        <div @click="modal9 = false" style="grid-area: c">
          <MenuItem

            v-if="display_report"
            name="report"
            :to="getView('report').children[0]"
          >
            <div class="info-box">
              📄<br/>
              <span>{{ getView("report").label }}</span>
            </div>
            <img src="/static/img/menu_background/report.png" alt="">

          </MenuItem>
        </div>

        <div @click="modal9 = false" style="grid-area: d">
          <MenuItem
            v-if="permissions.indexOf('money_order.moneyorder_app') !== -1"
            name="operations"
            :to="getView('operations').children[0]">
            <div class="info-box">
              📈<br/>
              <span>{{ getView("operations").label }}</span>
            </div>
            <img src="/static/img/menu_background/operations.png" alt="">

          </MenuItem>
        </div>

        <div @click="modal9 = false" style="grid-area: e">
          <MenuItem
            v-if="display_company"
            name="company_main"
            :to="getView('company_main').children[0]">
            <div class="info-box">
              🏢<br/>
              <span>{{ getView("company_main").label }}</span>
            </div>
            <img src="/static/img/menu_background/company.png" alt="">

          </MenuItem>
        </div>

        <div @click="modal9 = false" style="grid-area: f">
          <MenuItem
            name="payment"
            :to="getView('payments').children[0]">
            <div class="info-box">
              💳<br/>
              <span>{{ getView("payment").label }}</span>
            </div>
            <img src="/static/img/menu_background/payment.png" alt="">
          </MenuItem>
        </div>

        <div @click="modal9 = false" style="grid-area: g">
          <MenuItem
            name="counterpart"
            :to="getView('counterpart').children[0]">
            <div class="info-box">
              👥<br/>
              <span>{{ getView("counterpart").label }}</span>
            </div>
            <img src="/static/img/menu_background/counterparts.png" alt="">
          </MenuItem>
        </div>

        <div @click="modal9 = false" style="grid-area: h">
          <MenuItem
            name="integrations"
            :to="getView('integrations')">
            <div class="info-box">
              🕹️<br/>
              <span>{{ getView("integrations").label }}</span>
            </div>
          </MenuItem>
        </div>

        <div style="grid-area: i" class="cash-box-menu ivu-menu-item">
          <a :href="kassa_addr">
            <div class="info-box">
              🖱️ <br>
              <span>Касса</span>
            </div>
            <img src="/static/img/menu_background/cash.png" alt="">
          </a>
        </div>
      </div>

    </Modal>

    <!-- LEFT SIDER -->
    <Sider class="ls-main-sider" :class="{'left-sidebar': current_view.name === 'home' }">
      <div class="ls-main-sider-menu">
        <!--<Menu-->
        <!--active-name="home"-->
        <!--theme="light"-->
        <!--width="auto"-->
        <!--:open-names="[current_view_parent.name]"-->
        <!--&gt;-->
        <Menu
          class="mainMenu"
          v-if="current_view.name === 'home'"
          theme="light"
          width="auto"
          :open-names="[current_view_parent.name]"
        >
          <MenuItem v-if="display_home" name="home" :to="{ name: 'home' }"
                    style="grid-area: a">
            <div class="info-box">
              🏠 <br>
              <span>{{ getView("home").label }}</span>
            </div>
            <img src="/static/img/menu_background/main.png" alt="">
          </MenuItem>

          <MenuItem
            style="grid-area: b"
            v-if="permissions.indexOf('catalog.product_app') !== -1"
            name="catalog"
            :to="getView('catalog').children[0]"
          >
            <div class="info-box">
              🎁<br/>
              <span>{{ getView("catalog").label }}</span>
            </div>
            <img src="/static/img/menu_background/products.png" alt="">
          </MenuItem>


          <MenuItem
            style="grid-area: c"
            v-if="display_report"
            name="report"
            :to="getView('report').children[0]"
          >
            <div class="info-box">
              📄<br/>
              <span>{{ getView("report").label }}</span>
            </div>
            <img src="/static/img/menu_background/report.png" alt="">

          </MenuItem>


          <MenuItem
            style="grid-area: d"
            v-if="permissions.indexOf('money_order.moneyorder_app') !== -1"
            name="operations"
            :to="getView('operations').children[0]">
            <div class="info-box">
              📈<br/>
              <span>{{ getView("operations").label }}</span>
            </div>
            <img src="/static/img/menu_background/operations.png" alt="">

          </MenuItem>

          <MenuItem
            style="grid-area: e"
            v-if="display_company"
            name="company_main"
            :to="getView('company_main').children[0]">
            <div class="info-box">
              🏢<br/>
              <span>{{ getView("company_main").label }}</span>
            </div>
            <img src="/static/img/menu_background/company.png" alt="">

          </MenuItem>

          <MenuItem
            style="grid-area: f"
            name="payments"
            :to="getView('payments').children[0]"
          >
            <div class="info-box">
              💳<br/>
              <span>{{ getView("payment").label }}</span>
            </div>
            <img src="/static/img/menu_background/payment.png" alt="">
          </MenuItem>

          <MenuItem
            style="grid-area: g"
            name="counterpart"
            :to="getView('counterpart').children[0]">
            <div class="info-box">
              👥<br/>
              <span>{{ getView("counterpart").label }}</span>
            </div>
            <img src="/static/img/menu_background/counterparts.png" alt="">
          </MenuItem>

          <MenuItem
            style="grid-area: h"
            name="integrations"
            :to="getView('integrations').name">
            <div class="info-box">
              🕹️<br/>
              <span>{{ getView("integrations").label }}</span>
            </div>
          </MenuItem>

        </Menu>


        <!-- Меню для разделов-->
        <Menu
          class="menu__submenu"
          :active-name="current_view.name"
          theme="light"
          width="auto"

        >

          <!--ТОВАРЫ И УСЛУГИ-->
          <div v-if="current_view.category === 'catalog'">
            <div class="card-container card-title__submenu">
              <div class="info-box">
                🎁<br/>
                <span>{{ getView("catalog").label }}</span>
              </div>
              <img src="/static/img/menu_background/submenu/products.png" alt="" class="desktop_img">
              <img src="/static/img/menu_background/submenu/products_mob.png" alt="" class="mobile_img">
            </div>
            <div class="points-box">
              <MenuItem
                v-for="el in getView('catalog').children"
                :key="el.name"
                :name="el.name"
                :class="{'ivu-menu-item-active': current_view.name === el.name}"
                :to="{ name: el.name }"

              >

                <div class="card-container">
                  <h3>
                    {{ el.label }}
                  </h3>
                </div>
              </MenuItem>
            </div>

          </div>


          <!--Отчеты и аналитика-->
          <div v-if="current_view.category === 'report'">
            <div class="card-container card-title__submenu">
              <div class="info-box">
                📄<br/>
                <span>{{ getView("report").label }}</span>
              </div>
              <img src="/static/img/menu_background/submenu/report.png" alt="" class="desktop_img">
              <img src="/static/img/menu_background/submenu/report_mob.png" alt="" class="mobile_img">
            </div>
            <div class="points-box">
              <MenuItem
                :class="{'ivu-menu-item-active': current_view.name === el.name}"
                v-for="el in getView('report').children"
                :key="el.name"
                :name="el.name"
                :to="{ name: el.name }"
              >
                <div class="card-container">
                  <h3>
                    {{ el.label }}
                  </h3>
                </div>
              </MenuItem>
            </div>

          </div>


          <!--ОПЕРАЦИИ-->
          <div v-if="current_view.category === 'operations'">
            <div class="card-container card-title__submenu">
              <div class="info-box">
                📈<br/>
                <span>{{ getView("operations").label }}</span>
              </div>
              <img src="/static/img/menu_background/submenu/operations.png" alt="" class="desktop_img">
              <img src="/static/img/menu_background/submenu/operations_mob.png" alt="" class="mobile_img">
            </div>
            <div class="points-box">
              <MenuItem
                :class="{'ivu-menu-item-active': current_view.name === el.name}"
                v-for="el in getView('operations').children"
                :key="el.name"
                :name="el.name"
                :to="{ name: el.name }"
              >
                <div class="card-container">
                  <h3>
                    {{ el.label }}
                  </h3>
                </div>
              </MenuItem>
            </div>

          </div>


          <!--КОМПАНИИ-->
          <div v-if="current_view.category === 'company_main'">
            <div class="card-container card-title__submenu">
              <div class="info-box">
                🏢<br/>
                <span>{{ getView("company_main").label }}</span>
              </div>
              <img src="/static/img/menu_background/submenu/company.png" alt="" class="desktop_img">
              <img src="/static/img/menu_background/submenu/company_mob.png" alt="" class="mobile_img">
            </div>

            <div class="points-box">
              <MenuItem
                :class="{'ivu-menu-item-active': current_view.name === el.name}"
                v-for="el in getView('company_main').children"
                :key="el.name"
                :name="el.name"
                :to="{ name: el.name }"
              >
                <div class="card-container">
                  <h3>
                    {{ el.label }}
                  </h3>
                </div>
              </MenuItem>
            </div>

          </div>


          <!--КОНТРАГЕНТЫ-->
          <div v-if="current_view.category === 'counterpart'">
            <div class="card-container card-title__submenu">
              <div class="info-box">
                👥<br/>
                <span>{{ getView("counterpart").label }}</span>
              </div>
            </div>

            <div class="points-box">
              <MenuItem
                :class="{'ivu-menu-item-active': current_view.name === el.name}"
                v-for="el in getView('counterpart').children"
                :key="el.name"
                :name="el.name"
                :to="{ name: el.name }"
              >
                <div class="card-container">
                  <h3>
                    {{ el.label }}
                  </h3>
                </div>
              </MenuItem>
            </div>

          </div>


          <!--ОПЛАТА-->
          <div v-if="current_view.category === 'payments'">
            <div class="card-container card-title__submenu">
              <div class="info-box">
                💳<br/>
                <span>{{ getView("payment").label }}</span>
              </div>
            </div>

            <div class="points-box">
              <MenuItem
                :class="{'ivu-menu-item-active': current_view.name === el.name}"
                v-for="el in getView('payments').children"
                :key="el.name"
                :name="el.name"
                :to="{ name: el.name }"
              >
                <div class="card-container">
                  <h3>
                    {{ el.label }}
                  </h3>
                </div>
              </MenuItem>
            </div>

          </div>

          <!--МОДУЛИ И ИНТЕГРАЦИЯ-->
          <div v-if="current_view.category === 'integrations'">
            <div class="card-container card-title__submenu">
              <div class="info-box">
                🕹️<br/>
                <span>{{ getView("integrations").label }}</span>
              </div>
            </div>
          </div>


        </Menu>


      </div>
    </Sider>

    <!-- MAIN CONTENT + MAIN FOOTER -->
    <Layout
      :class="{'main-container__home': current_view.name === 'home', 'main-container': current_view.name != 'home'}">
      <!--&lt;!&ndash; BREADCRUMB &ndash;&gt;-->
      <!--<Breadcrumb class="ls-breadcrumb">-->
      <!--<BreadcrumbItem to="/">-->
      <!--<Icon type="ios-apps"></Icon>-->
      <!--Главная-->
      <!--</BreadcrumbItem>-->

      <!--<BreadcrumbItem v-if="current_view.name !== 'main'">-->
      <!--<Icon :type="current_view.icon"></Icon>-->
      <!--{{ current_view.label }}-->
      <!--</BreadcrumbItem>-->
      <!--</Breadcrumb>-->

      <!-- MAIN CONTENT -->
      <Content class="ls-main-content">
        <router-view :key="reloadMainContentKey"/>

        <!-- MODAL WITH PREVIEW CONTENT -->
        <Modal
          class="modal_hide_close preview_modal"
          :footer-hide="footerHide"
          v-model="previewModal">
          <div class="fs-16" style="padding: 12px">
            <p class="mb-24">По началу работы советуем ознакомиться с видеоинструкциями.</p>

            <p class="mb-24">
              <span>Вы всегда можете вернуться к инструкциям, нажав в верхней панели экрана на иконку</span>
            </p>

            <div class="d-flex justify-center">
              <Button type="error" @click="previewModal = false" style="margin: 0 12px">Позже</Button>
              <Button type="success" @click="showFirstly(user_id)" style="margin: 0 12px">Ознакомиться</Button>
            </div>
          </div>
        </Modal>



        <div class="custom-wrap" v-if="videoListModal" @click="videoListModal = false"></div>
        <!-- MODAL WITH VIDEO CONTENT -->
        <Modal
          class="video_modal"
          width="80%"
          :footer-hide="footerHide"
          v-model="videoModal">
          <iframe v-if="activeVideo" width="100%" height="600px" :src="activeVideo.url + '?start=1&autoplay=1'" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </Modal>
      </Content>
    </Layout>

  </Layout>


</template>
<script>


    import modalPass from "../apps/user/modalPass.vue";


    import {mapState} from "vuex";
    import {apps} from "../apps.js";
    import {base_url, server_addr, kassa_addr} from "../http.js";
    import {
        TYPE_SELL,
        TYPE_PURCHASE,
        TYPE_RETURN_SELL,
        TYPE_RETURN_PURCHASE,
        TYPE_CHANGES_IN,
        TYPE_CHANGES_OUT,
        TYPE_MOVING,
        TYPE_CHANGES_INVENTORY
    } from "../apps/product_order/const.js";


    export default {
        name: "baseApp",
        data() {
            return {
                // user_id: '',
                // user_full_name: "Пользователь",
                apps: apps,
                // current_view: "",
                // current_view_parent: "",
                reloadMainContentKey: 0,
                // reloadLeftSiderKey: 0
                modal9: false,
                closeBurger: false,

                modalPassword: false,
                user_img: '',
                server_addr: server_addr,

                videoList: '',
                videoModal: false,
                footerHide: true,
                activeVideo: '',

                previewModal: false,
                videoListModal: false,
            };
        },
        components: {
            modalPass
        },
        computed: {
            kassa_addr() {
                return kassa_addr;
            },

            user_name_avatar() {
                let arr = this.user_full_name.split(" ", 2);
                if (arr.length > 1) {
                    return arr[0].substr(0, 1) + arr[1].substr(0, 1);
                } else {
                    return arr[0];
                }
            },
            // permissions() {
            //   return JSON.parse(localStorage.getItem("permissions"));
            // },
            // Показываем пункт иеню "Главная" только для владельца либо управляющкего (выбираем по праву просмотра сотрудников)
            display_company() {
                // return this.permissions.indexOf('company.app')!==-1;
                return (
                    this.permissions.indexOf("company.company_app") !== -1 ||
                    this.permissions.indexOf("user.user_app") !== -1 ||
                    this.permissions.indexOf("store.store_app") !== -1 ||
                    this.permissions.indexOf("account.account_app") !== -1
                );
            },

            display_home() {
                // Показываем только для Владельца и Управляющего
                // return this.permissions.indexOf("user.user_app") !== -1
                return this.role !== "cashier" && this.role !== "storekeeper";
            },

            display_report() {
                // Показываем только для Владельца и Управляющего
                return this.permissions.indexOf("user.user_app") !== -1;
            },

            ...mapState([
                "user_id",
                "user_full_name",
                "current_view",
                "current_view_parent",
                "currency",
                "permissions",
                "role",
                "role_display"
            ]),

            isLaptop() {
                return window.innerWidth < 1200 && window.innerWidth > 991;
            },

            isDesktop() {
                return window.innerWidth >= 1200;
            },

            isMobile() {
                return window.innerWidth < 991;
            },


            // user_id() {
            //   return this.$store.state.user_id;
            // },
            // user_full_name() {
            //   return this.$store.state.user_full_name;
            // },
            // current_view() {
            //   return this.$store.state.current_view;
            // },
            // current_view_parent() {
            //   return this.$store.state.current_view_parent;
            // },
            // currency() {
            //   return this.$store.state.currency;
            // },
            // permissions() {
            //   return this.$store.state.permissions;
            // },
        },
        watch: {
            $route(to, from) {
                this.setCurrentView(to.name);
                // this.setCurrentView(this.$route.name);
                // this.setCurrentParentView(to.name);
            },
            videoModal(item) {
                if(item === false) this.activeVideo = '';
            }

        },
        methods: {
            getView(appName) {
                for (let app of this.apps) {
                    // if (app.name === appName) {
                    // console.log(appName+ ' indexOf '+ app.name +': '+ appName.indexOf(app.name));
                    if (appName.indexOf(app.name) === 0) {
                        return app;
                    } else if ("children" in app) {
                        for (let child_app of app.children) {
                            // if (child_app.name === appName) {
                            if (appName.indexOf(child_app.name) === 0) {
                                return child_app;
                            }
                        }
                    }
                }
            },

            setCurrentView(appName) {
                this.$store.commit("current_view", this.getView(appName));
                // this.current_view = this.getView(appName);
            },

            setCurrentParentView(appName) {
                for (let app of this.apps) {
                    if ("children" in app) {
                        for (let child_app of app.children) {
                            // if (child_app.name === appName) {
                            if (appName.indexOf(child_app.name) === 0) {
                                // this.current_view_parent = app;
                                this.$store.commit("current_view_parent", app);
                            }
                        }
                    }
                }
            },

            logout() {
                this.loading = true;

                this.$store
                    .dispatch("logout", {vm: this})
                    .then(() => {
                        this.loading = false;
                        this.$router.push({name: "login"});
                    })
                    .catch(error => {
                        this.$Message.error('Ошибка');
                        console.error(error);
                    })
                    .then(() => {
                        this.loading = false;
                    });


            },

            fetchCurrentUser() {
                const path = "/current_user/";
                this.loading = true;
                this.$http
                    .get(base_url + path)
                    .then(response => {
                        let data = response.data;
                        this.$store.commit("user_id", data.id);
                        this.$store.commit("user_full_name", data.full_name);
                        this.$store.commit("currency", data.currency);
                        this.$store.commit("permissions", data.permissions);
                        this.$store.commit("role", data.role);
                        this.$store.commit("role_display", data.role_display);
                        this.$store.commit("use_fiscal", data.use_fiscal);
                        this.$store.commit("company_name", data.company_name);
                        this.$store.commit("cashes", data.cashes);
                        // this.$store.commit("image_url", data.image_url);


                        if (data.role === "cashier" || data.role === "storekeeper") {
                            this.$router.push("catalog");
                        }

                        if(this.$route.meta.role_banned === this.$store.state.role) {
                            window.location.href = kassa_addr
                        }

                        this.getVideoList(this.user_id);
                        // this.user_full_name = response.data.full_name;
                        // this.user_id = response.data.id;
                        // localStorage.setItem('user_id', response.data.id);
                        // localStorage.setItem('user_full_name', response.data.full_name);
                        // localStorage.setItem('currency', response.data.currency);
                        // localStorage.setItem("permissions", JSON.stringify(response.data.permissions));

                        // this.forceRerenderLeftSider();
                        // if (!this.display_main) {
                        //   // this.$router.go({name: 'catalog'});
                        //   this.$router.push({
                        //     name: 'catalog'
                        //   });
                        // }
                    })
                    .catch(error => {
                        this.$Message.error(
                            "Ошибка получения информации о текущем пользователе"
                        );
                    })
                    .then(() => {
                        this.loading = false;


                    });
                // this.$Message.success('Success!');
            },

            selectDocAction(item) {
                // console.log(item);
                let reload = false;
                switch (item) {
                    case TYPE_SELL:
                        if (this.$route.name === "product_order_create") reload = true;
                        this.$router.push({
                            name: "product_order_create",
                            query: {type: TYPE_SELL}
                        });
                        if (reload) this.forceRerenderMainContent();
                        break;
                    case TYPE_PURCHASE:
                        if (this.$route.name === "product_order_create") reload = true;
                        this.$router.push({
                            name: "product_order_create",
                            query: {type: TYPE_PURCHASE}
                        });
                        if (reload) this.forceRerenderMainContent();
                        break;
                    case TYPE_RETURN_SELL:
                        if (this.$route.name === "product_order_create") reload = true;
                        this.$router.push({
                            name: "product_order_create",
                            query: {type: TYPE_RETURN_SELL}
                        });
                        if (reload) this.forceRerenderMainContent();
                        break;
                    case TYPE_RETURN_PURCHASE:
                        if (this.$route.name === "product_order_create") reload = true;
                        this.$router.push({
                            name: "product_order_create",
                            query: {type: TYPE_RETURN_PURCHASE}
                        });
                        if (reload) this.forceRerenderMainContent();
                        break;
                    case TYPE_CHANGES_IN:
                        if (this.$route.name === "product_order_change_in_create")
                            reload = true;
                        this.$router.push({
                            name: "product_order_change_in_create"
                        });
                        if (reload) this.forceRerenderMainContent();
                        break;
                    case TYPE_CHANGES_OUT:
                        if (this.$route.name === "product_order_change_out_create")
                            reload = true;
                        this.$router.push({
                            name: "product_order_change_out_create"
                        });
                        if (reload) this.forceRerenderMainContent();
                        break;
                    case TYPE_MOVING:
                        if (this.$route.name === "product_order_change_moving_create")
                            reload = true;
                        this.$router.push({
                            name: "product_order_change_moving_create"
                        });
                        if (reload) this.forceRerenderMainContent();
                        break;
                    case TYPE_CHANGES_INVENTORY:
                        if (this.$route.name === "product_order_inventory_create")
                            reload = true;
                        this.$router.push({
                            name: "product_order_inventory_create"
                        });
                        if (reload) this.forceRerenderMainContent();
                        break;

                    case "coming":
                        this.$router.push({
                            name: "money_order_create",
                            query: {type: "coming"}
                        });
                        break;
                    case "outgoing":
                        this.$router.push({
                            name: "money_order_create",
                            query: {type: "outgoing"}
                        });
                        break;
                    case "transfer":
                        this.$router.push({
                            name: "money_order_create_transfer"
                            // query: { type: "outgoing" }
                        });
                        break;
                    // case "debt_repayment":
                    //     this.$router.push({
                    //         name: "debt_repayment_create"
                    //     });
                    //     if (reload) this.forceRerenderMainContent();
                    //     break;
                    default:
                }
            },

            forceRerenderMainContent() {
                this.reloadMainContentKey += 1;
            },

            // forceRerenderLeftSider() {
            //   this.reloadLeftSiderKey += 1;
            // },

            display_counterpart_item(item) {
                return this.permissions.indexOf(`${item.name}.${item.name}_app`) !== -1;
            },

            display_company_item(item) {
                if (item.name === "user") {
                    return this.permissions.indexOf(`${item.name}.user_app`) !== -1;
                }
                return this.permissions.indexOf(`${item.name}.${item.name}_app`) !== -1;
            },

            getUserImg() {
                const url = base_url + "/current_user/";
                this.$http
                    .get(url)
                    .then(result => {
                        this.user_img = result.data.image_url;
                    });
            },


            getVideoList(id) {
                const url = server_addr + "/media/manuals.json";

                this.$http({
                    header: {
                        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
                        'Accept-Encoding': 'gzip,deflate',
                        'Accept-Charset': 'ISO-8859-1,utf-8;q=0.7,*;q=0.7',
                        'Connection': 'keep-alive'

                    },
                    method: "get",
                    url: url,
                })
                    .then(result => {
                        this.videoList = result.data;
                        if(localStorage.getItem('first_time_login') === null ||
                            localStorage.getItem('first_time_login__' + id) === null
                        )  {
                            this.previewModal = true;
                            localStorage.setItem('first_time_login', '1');
                            localStorage.setItem('first_time_login__' + id, id);
                        }
                    })
            },

            showFirstly(id) {

                this.previewModal = false;
                localStorage.setItem('first_time_login', '1');
                localStorage.setItem('first_time_login__' + id, id);
                this.videoListModal = true;
            },

            showVideoList() {
                this.videoListModal = !this.videoListModal;
            },

            showVideo(item) {
                this.activeVideo = item;
                this.videoModal = true;
            }


        },
        created() {
            this.loading = true;
            this.fetchCurrentUser();

            // if (this.$route.name !== 'current_user') {
            this.setCurrentView(this.$route.name);
            this.setCurrentParentView(this.$route.name);
            //  }

            this.TYPE_SELL = TYPE_SELL;
            this.TYPE_PURCHASE = TYPE_PURCHASE;
            this.TYPE_RETURN_SELL = TYPE_RETURN_SELL;
            this.TYPE_RETURN_PURCHASE = TYPE_RETURN_PURCHASE;
            this.TYPE_CHANGES_IN = TYPE_CHANGES_IN;
            this.TYPE_CHANGES_OUT = TYPE_CHANGES_OUT;
            this.TYPE_MOVING = TYPE_MOVING;
            this.TYPE_CHANGES_INVENTORY = TYPE_CHANGES_INVENTORY;

            // this.getVideoList();


            // for (let app of apps) {
            //   if (app.name === this.$route.name) {
            //     // this.current_view = app;
            //     this.setCurrentView(this.$route.name);
            //   }
            // }
            // this.current_view = apps[this.$route.name];
        },
        mounted() {
            this.getUserImg();

            // this.getVideoList();
            // this.fetchCurrentUser();
        }
        // beforeMount() {
        //   this.$Spin.hide();
        // }

    };
</script>


<style scoped>

  .main-header {
    height: auto;
    padding: 20px 40px;
    background: #ffffff;
    position: fixed;
    width: 100%;
    z-index: 102;
    top: 0;
    left: 0;
    font-weight: 400;
    line-height: 1.2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #0E254A;

  }

  .main-header__home {
    padding: 20px 416px 20px 40px;
  }

  .menuBtn {
    margin-right: 24px;
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 50%;
  }

  .menuBtn.closeBurger {
    z-index: 10;
    position: absolute;
    background-color: #ffffff;

  }

  .menuBtn img {
    height: 16px;
  }

  .mainLogo {
    margin-right: 40px;
    height: auto;
  }

  .mainLogo img {
    width: 110px;
  }


  .layout-view-name {
    padding-left: 30px;
    position: relative;
    height: auto;
  }

  .layout-view-name h3 {
    display: block;
    font-weight: bold;
    font-size: 20px;
    color: rgba(37, 215, 126, 1);
    margin: 0;

  }

  .layout-view-name::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    background: rgba(37, 215, 126, 1);
    border-radius: 50%;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }


  .cash-box {
    width: 360px;
    text-align: center;
    padding: 10px 0;
    border-radius: 25px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    background: url("/static/img/cash.png");
    background-size: cover;
  }

  .header-icons {
    display: flex;
    align-items: center;
    margin-left: 30px;
  }

  .header-icons .header-icons__box {
    margin-right: 18px;
    position: relative;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    background-color: #F1F1F1;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header-icons .header-icons__box.active {
    position: relative;
    z-index: 1007;
  }

 .header-icons .header-icons__box img {
    width: 20px;
    height: 20px;
  }

  .header-icons .header-icons__box:last-child {
    margin-right: 0;
  }

  .header-icons .header-icons__box .notification {
    position: absolute;
    width: 33px;
    height: 33px;
    border-radius: 50%;
    background-color: #25D87E;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    top: -8px;
    left: -8px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 15px;
    font-weight: bold;
  }

  /*profile for HOME page*/
  .layout-profile__main {
    width: 336px;
    position: absolute;
    z-index: 10;
    top: 20px;
    right: 40px;
    margin-top: 58px;
    padding: 0 25px 35px;
  }

  .layout-profile__main .ivu-avatar {
    margin: 0 auto;
    width: 80px;
    height: 80px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 50%;
    transform: translateY(-50%);
    display: block;
    background-color: transparent;
  }

  .layout-profile__main .ivu-avatar img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    transform: scale(1.1);
  }

  .layout-profile__main .layout-profile__body {
    margin-top: -25px;
  }

  .layout-profile__main .layout-profile__body h2 {
    text-align: center;
    margin-bottom: 24px;
  }

  .layout-profile__main .layout-profile__body .card-container {
    text-align: center;
    /*font-size: 16px;*/
    width: 100%;
    margin-bottom: 20px;
    display: block;
    border-radius: 25px;
  }

  .layout-profile__main .layout-profile__body a.card-container {
    padding: 15px;
  }

  .layout-profile__main .layout-profile__body .card-container:hover {
    background-color: #ffffff;
  }

  .layout-profile__main .layout-profile__body .logout {
    text-align: center;
    font-size: 16px;
    color: #ED4729;
    font-weight: bold;
  }

  .layout-profile__main .layout-profile__body .logout span {
    text-decoration: underline;
  }


  /*profile for OTHER pages*/
  .layout-profile {
    margin-left: 18px;
    color: #0E254A;
    /*padding: 12px 0;*/
  }

  .layout-profile .ivu-menu {
    line-height: 1.2;
    height: auto;
  }

  .ivu-menu-vertical.ivu-menu-light::after {
    content: none;
  }

  .layout-profile .ls-main-menu-item {
    border: none;
  }

  .ivu-menu-horizontal.ivu-menu-light:after {
    content: none;
  }

  .layout-profile .ivu-menu-submenu-title {
    padding: 12px 0;
    display: flex;
    align-items: center;
  }

  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    border-bottom: none;
    color: #0E254A;
  }

  .layout-profile .ivu-avatar {
    margin: 12px 20px 12px 0;
    width: 44px;
    height: 44px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 50%;
    display: inline-block;
    padding: 0;
    background-color: transparent;
  }

  .layout-profile .ivu-avatar img {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    transform: scale(1.2);
  }


  .layout-profile span.name {
    font-size: 16px;
    font-weight: bold;
  }

  .layout-profile .layout-profile__body {
    padding: 0 12px;
  }

  .layout-profile .layout-profile__body .card-container {
    text-align: center;
    font-size: 16px;
    width: 100%;
    margin-bottom: 20px;
    display: block;
    border-radius: 25px;
  }

  .layout-profile .layout-profile__body a.card-container {
    padding: 15px;
  }

  .layout-profile .layout-profile__body .logout {
    text-align: center;
    font-size: 16px;
    color: #ED4729;
    font-weight: bold;
  }

  .layout-profile .layout-profile__body .logout span {
    text-decoration: underline;
  }

  /*SIDEBAR*/

  .ls-main-sider {
    min-width: auto;
    border-right: none;
    width: auto !important;
    max-width: 100% !important;
    flex: 0 0 0 !important;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 50;
    padding: 0;
    background: #ffffff;
  }

  .ls-main-sider-menu {
    padding: 110px 0 20px 0;
  }


  /*MENU*/

  .mainMenu {
    padding-bottom: 10px;
    padding-left: 40px;
    display: grid;
    grid-template-columns: repeat(2, 150px);
    grid-template-rows: repeat(5, 120px);
    grid-gap: 24px;
    padding-right: 10px;
    grid-template-areas: "a b" "c b" "c d" "e f" "g h" "i i";
  }

  .mainMenu .cash-box-menu {
    display: none;
  }

  .mainMenu .ivu-menu-item {
    font-size: 20px;
    font-weight: bold;
    border-radius: 25px;
    padding: 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    height: 100%;
    background-color: #F1F1F1;
    position: relative;
    transition: 0.3s ease-in;
    overflow: hidden;
  }

  .mainMenu .ivu-menu-item:hover {
    color: #000000;
    box-shadow: 0 4px 7px rgba(0, 0, 0, 0.26);
  }

  .mainMenu .ivu-menu-item:hover img {
    transform: scale(1.08);
  }

  .mainMenu .ivu-menu-item img {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 0.3s ease-in;
    transform-origin: right bottom;
  }

  .mainMenu .ivu-menu-item .info-box {
    position: relative;
    z-index: 2;
  }

  .mainMenu .ivu-menu-item .info-box span {
    display: block;
    padding-top: 5px;
    line-height: 1.2
  }


  /***SUBMENU**/
  .menu__submenu {
    padding-left: 40px;
    padding-right: 10px;
  }

  .menu__submenu .ivu-menu-item {
    padding: 0;
    margin-bottom: 20px;
    border-radius: 25px;
  }

  .menu__submenu .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background-color: #ffffff;
  }

  .menu__submenu .ivu-menu-item.ivu-menu-item-active::after {
    content: none;
  }

  .menu__submenu .card-container {
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F1F1F1;
    text-align: center;
    width: 150px;
    padding: 5px;
  }

  .menu__submenu .card-container h3 {
    font-size: 16px;
  }

  .menu__submenu .ivu-menu-item.ivu-menu-item-active .card-container {
    background-color: #1DBDC6;

  }

  .menu__submenu .ivu-menu-item.ivu-menu-item-active .card-container h3 {
    color: #ffffff;
  }

  .menu__submenu .card-container.card-title__submenu {
    height: 264px;
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
    display: block;
    color: #ffffff;
    padding: 17px 20px;
    text-align: left;
    background-color: #1DBDC6;
    position: relative;
    overflow: hidden;

  }

  .menu__submenu .card-container.card-title__submenu .mobile_img {
    display: none;
  }


  .card-title__submenu .info-box {
    position: relative;
    z-index: 2;
  }

  .card-title__submenu img.desktop_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  .card-title__submenu img.mobile_img {
    width: auto;
    height: 100%;
    object-fit: cover;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;

  }



  .custom-wrap {
    position: fixed;
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
  }




  /*  ADAPTIVE */
  @media screen and (max-width: 1900px) {

    .main-header__home {
      padding: 20px 360px 20px 40px;
    }

    .layout-profile__main {
      width: 280px;
      right: 40px;
    }

    .layout-profile__main .layout-profile__body {
      margin-top: -25px;
    }

    .ls-main-sider-menu {
      padding-top: 100px;
    }

    .mainMenu {
      padding-left: 40px;
      grid-template-columns: repeat(2, 130px);
      grid-template-rows: repeat(5, 100px);
      grid-gap: 15px;
    }

    .mainMenu .ivu-menu-item {
      font-size: 18px;
      padding: 12px 10px;
    }

    .menu__submenu {
      padding-left: 40px;
      padding-top: 10px;
    }

    .menu__submenu .card-container {
      width: 130px;
      overflow: hidden;
      min-height: 46px;
    }

    .menu__submenu .card-title__submenu {
      height: 215px;
      font-size: 18px;
      padding: 17px 10px;
    }

  }


  @media screen and (max-width: 1500px) {
    .main-header__home {
      padding-right: 260px;
    }

    .ls-main-sider-menu {
      padding-top: 85px;
    }

    .menuBtn {
      margin-right: 24px;
      height: 40px;
      width: 40px;
    }

    .menuBtn img {
      width: 20px;
    }

    .mainLogo {
      height: auto;
    }

    .mainLogo img {
      width: 90px;
    }

    .cash-box {
      width: 320px;
      text-align: center;
      padding: 10px 0;
    }

    .header-icons .header-icons__box, .header-icons .header-icons__box {
      width: 40px;
      height: 40px;
    }


    .layout-profile__main {
      width: 200px;
      margin-top: 30px;
      padding: 0 15px 20px;
    }

    .layout-profile__main .layout-profile__body {
      margin-top: -10px;
    }

    .layout-profile__main .ivu-avatar {
      width: 60px;
      height: 60px;
    }

    .layout-profile__main .ivu-avatar img {
      width: 60px;
      height: 60px;
      transform: scale(1.2);
    }

    .layout-profile__main .layout-profile__body .logout, .layout-profile__main .layout-profile__body .card-container {
      font-size: 14px;
    }

    .layout-profile__main .layout-profile__body a.card-container {
      padding: 10px;
    }

    .layout-profile__main .layout-profile__body button.card-container {
      height: 36px;
      padding: 0;
    }

    .layout-profile__main .ivu-avatar {
      font-size: 20px;
    }

    .layout-profile__main .layout-profile__body h2 {
      margin-bottom: 20px;
    }

    .layout-profile .ivu-avatar {
      width: 30px;
      height: 30px;
      margin: 5px 20px 5px 0;
    }

    .layout-profile .ivu-avatar img {
      width: 30px;
      height: 30px;
      transform: scale(1.4);
    }

    .layout-profile .layout-profile__body a.card-container {
      padding: 10px;
    }

    .layout-profile .layout-profile__body button.card-container {
      padding: 0;
      height: 36px;
    }

    .layout-view-name {
      padding-left: 30px;
    }

    .layout-view-name h3 {
      font-size: 15px;
    }

    .layout-view-name::before {
      width: 15px;
      height: 15px;
    }

    .layout-profile .layout-profile__body .card-container {
      font-size: 14px;
    }

    .ls-main-sider {
      padding: 0;
    }

    .mainMenu .ivu-menu-item .info-box {
      font-size: 15px;
    }

    .mainMenu {
      padding-left: 40px;
      grid-template-columns: repeat(2, 110px);
      grid-template-rows: repeat(5, 80px);
      grid-gap: 15px;
    }

    /*.menu__submenu .card-container {*/
    /*  width: 110px;*/
    /*  overflow: hidden;*/
    /*  min-height: 46px;*/
    /*}*/
    .menu__submenu .card-container.card-title__submenu {
      font-size: 16px;
    }

    .menu__submenu .card-title__submenu {
      height: 175px;
      padding: 17px 10px;
    }

    .menu__submenu .card-container h3 {
      font-size: 15px;
    }

  }

  /*ADAPTIVE ***** 1200 ********/
  @media screen and (max-width: 1200px) {
    .main-header__home {
      padding: 20px 40px;
    }

    .ls-main-sider {
      position: static;
      width: 100% !important;
      max-width: 100% !important;
    }

    .ls-main-sider .points-box {
      display: flex;
      white-space: nowrap;
      overflow-x: scroll;
    }

    .ls-main-sider-menu {
      padding-top: 0;
      padding-bottom: 5px;
    }

    .left-sidebar {
      display: none;
    }

    /*.cash-box {*/
    /*  display: none;*/
    /*}*/


    .mainMenu .cash-box-menu {
      display: block;
    }

    .menu__submenu .ivu-menu-item {
      padding: 0;
      margin-bottom: 0;
      border-radius: 0;
    }

    .menu__submenu .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
    .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
      background-color: transparent;
    }

    .menu__submenu .card-container {
      min-height: auto;
      background-color: transparent;
      width: auto;
      padding: 5px 25px 5px 0;
      box-shadow: none;
      margin-right: 10px;

    }

    .menu__submenu .card-container.card-title__submenu img.mobile_img {
      display: block;
    }

    .menu__submenu .card-container.card-title__submenu img.desktop_img {
      display: none;
    }


    .menu__submenu .card-container.card-title__submenu {
      height: auto;
      padding: 15px 20px;
      font-size: 15px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

    }

    .menu__submenu .card-container.card-title__submenu .info-box {
      display: flex;
    }

    .menu__submenu .card-container.card-title__submenu .info-box span {
      margin-left: 12px;
    }

    .menu__submenu .card-container h3 {
      font-weight: 400;
      color: #0E254A
    }

    .menu__submenu .ivu-menu-item.ivu-menu-item-active .card-container {
      background-color: transparent;
    }

    .menu__submenu .ivu-menu-item.ivu-menu-item-active .card-container h3 {
      color: #20BEC8;
      font-weight: bold;
    }


    .modalMenu .mainMenu {
      grid-template-columns: repeat(2, 150px);
      grid-template-rows: repeat(6, 100px);
    }

  }


  @media screen and (max-width: 991px) {
    .layout-view-name {
      display: none;
    }

    .cash-box {
      min-width: 100px;
      width: 50%;
      max-width: 150px;
    }

    .menuBtn {
      box-shadow: none;
    }

    .menuBtn img {
      width: 25px;
    }
  }


  @media screen and (max-width: 575px) {

    /*HEADER*/
    .main-header, .main-header__home {
      padding: 10px 20px;
    }

    .mainLogo, .layout-profile .name, .layout-profile i {
      display: none;
    }

    .layout-profile .ls-main-menu-item {
      padding: 0;
    }

    .layout-profile .ivu-avatar {
      margin: 0;
    }

    .layout-profile .ivu-avatar {
      width: 34px;
      height: 34px;
      position: relative;
      overflow: visible;
    }

    .layout-profile .ivu-avatar::before {
      content: url("/static/img/header_icons/edit.png");
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      transform: translate(-25%, -25%);
    }

    .layout-profile .ivu-avatar img {
      width: 34px;
      height: 34px;
      transform: scale(1.4);
    }

    .menu__submenu {
      padding-left: 20px;
    }

    .modalMenu .mainMenu {
      padding: 60px 25px 20px;
    }
  }


  @media screen and (max-width: 400px) {
    .modalMenu .mainMenu {
      grid-template-columns: repeat(2, 50%)
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/baseApp.vue